var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWinterBreakAsideDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 320,
    viewBox: "0 0 270 320",
    fill: "none",
    id: "svg46",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 28.5033,-0.0159683 34.9204,-15 28.5093,-0.0134811 M 28.5139,-0.00902827 44,-6.21323 28.5165,-0.00313793 m 0,0.00628477 L 44,6.21324 28.5139,0.00903881 M 28.5093,0.01349 34.9204,15 28.5033,0.0159788 m -0.0065,0 L 22.0797,15 28.4907,0.01349 M 28.4861,0.00903881 13,6.21324 28.4835,0.00314684 m 0,-0.00628477 L 13,-6.21323 28.4861,-0.00902827 M 28.4907,-0.0134811 22.0797,-15 28.4968,-0.0159683",
    stroke: "#edeef7",
    strokeWidth: 5,
    id: "path30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 0.503254,111.984 6.92035,97 0.509343,111.987 M 0.513942,111.991 16,105.787 0.516513,111.997 m 0,0.006 L 16,118.213 0.513942,112.009 M 0.509343,112.013 6.92035,127 0.503254,112.016 m -0.006494,0 L -5.92034,127 0.490672,112.013 M 0.486072,112.009 -15,118.213 0.483502,112.003 m 0,-0.006 L -15,105.787 0.486072,111.991 m 0.0046,-0.004 L -5.92034,97 l 6.4171,14.984",
    stroke: "#edeef7",
    strokeWidth: 5,
    id: "path32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 116.813,14.1659 c 0.026,-0.2212 0.348,-0.2212 0.374,0 l 0.22,1.8562 c 0.284,2.3968 2.174,4.2865 4.571,4.5709 l 1.856,0.2202 c 0.221,0.0263 0.221,0.3473 0,0.3736 l -1.856,0.2202 c -2.397,0.2844 -4.287,2.1741 -4.571,4.5709 l -0.22,1.8561 c -0.026,0.2213 -0.348,0.2213 -0.374,0 l -0.22,-1.8561 c -0.284,-2.3968 -2.174,-4.2865 -4.571,-4.5709 l -1.856,-0.2202 c -0.221,-0.0263 -0.221,-0.3473 0,-0.3736 l 1.856,-0.2202 c 2.397,-0.2844 4.287,-2.1741 4.571,-4.5709 z",
    stroke: "#edeef7",
    strokeWidth: 3,
    strokeLinejoin: "bevel",
    id: "path34"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs44"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37188_5840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 270,
    height: 320,
    rx: 8,
    fill: "white",
    id: "rect38"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_37188_5840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 189,
    height: 207,
    fill: "white",
    transform: "matrix(0.999957 -0.0092399 -0.0092399 -0.999957 177.169 106.738)",
    id: "rect41"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinterBreakAsideDesktop);
export default __webpack_public_path__ + "static/media/winterBreakAside_desktop.576ea5fdf5d01b2317c24ccc20d8c6e2.svg";
export { ForwardRef as ReactComponent };